import React from 'react';
import PropTypes from 'prop-types';

import Products from '../Products';
import { Wrap } from './styles';

const TrendingContent = ({ className, trendingProducts, handleClick }) => {
    return (
        <Wrap className={className}>
            <Products products={trendingProducts} handleClick={handleClick} />
        </Wrap>
    );
};

TrendingContent.propTypes = {
    className: PropTypes.string,
    trendingProducts: PropTypes.arrayOf(PropTypes.object),
    handleClick: PropTypes.func,
};

TrendingContent.defaultProps = {
    className: '',
    trendingProducts: [],
    handleClick: () => {},
};

export default TrendingContent;
